module.exports = __webpack_public_path__ + "img/indicate_icon_1.ad412dd2.png";